import React from "react"
import { Box, Button, Card, Typography } from "@mui/material"

export const SettingsFormLayout = (props) => {
  const {
    children,
    title,
    subTitle,
    buttonText,
    action,
    buttonVariant = 'contained',
    buttonColor = 'primary',
    disabled = false
  } = props;

  return (
    <Card>
      <Typography className="subTitle">{title}</Typography>
      <Typography variant="subtitle1" color="text.semiLight" mb={2}>{subTitle}</Typography>
      {children}
      <Box display={'flex'} alignItems={{ xs: 'center', sm: 'flex-end' }} justifyContent={{ xs: 'center', sm: 'flex-end' }} mt={2.5}>
        <Button disabled={disabled} sx={{ width: { xs: '100%', sm: '250px' } }} color={buttonColor} variant={buttonVariant} onClick={() => action()}>{buttonText}</Button>
      </Box>
    </Card >
  )
};